import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {BorderLabels} from '../../BorderLabels';
import {ContainerBuiltInControl} from '../ContainerBuiltInControl';

export abstract class ContainerBorderBuiltInControl extends ContainerBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.CONTAINER].BORDER_FORM;
  }

  public getLabels(): BorderLabels | undefined {
    return undefined;
  }
}
